export const DEVIDER = 1,
						 GRID_SCALE = 0.05;


// WEBPACK FOOTER //
// ./src/config.js